import { render, staticRenderFns } from "./DirectoryArchivedTable.vue?vue&type=template&id=1f68e124&scoped=true&"
import script from "./DirectoryArchivedTable.vue?vue&type=script&lang=js&"
export * from "./DirectoryArchivedTable.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryArchivedTable.vue?vue&type=style&index=0&id=1f68e124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f68e124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f68e124')) {
      api.createRecord('1f68e124', component.options)
    } else {
      api.reload('1f68e124', component.options)
    }
    module.hot.accept("./DirectoryArchivedTable.vue?vue&type=template&id=1f68e124&scoped=true&", function () {
      api.rerender('1f68e124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DirectoryArchivedTable.vue"
export default component.exports